import api from "../../../services/axiosConfig";

export const fetchUsers = async () => {
  try {
    const response = await api.get("/instances/skeye/skeyepredict/list-users", {
      data: {},
    });

    return response.data.data.users;
  } catch (error) {
    console.error("Error fetching Users:", error);
    throw error;
  }
};

export const createProject = async (projectData) => {
  try {
    const formData = new FormData();
    formData.append("id", projectData.name);
    formData.append("file", projectData.file);

    const response = await api.post(
      "/instances/skeye/skeyepredict/create-project",
      formData,
      {
        headers: {
          "Content-Type": undefined,
        },
        timeout: 300000,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating project:", error);
    throw error;
  }
};
